import { IconButton } from "@smartsuite/react-ui/lib/components/buttons/IconButton";
import { Tooltip } from "@smartsuite/react-ui/lib/components/help/Tooltip";
import { isDocEmpty } from "@smartsuite/smartdoc";
import cx from "clsx";
import { SmartDocRenderer } from "../SmartDocRenderer/SmartDocRenderer";
import { EditorData, GrayColors } from "@smartsuite/types";

import "./HelpTextTooltip.sass";

interface HelpTextTooltipProps {
  helpText?: EditorData;
  labelContainerRef: React.RefObject<HTMLDivElement>;
}

export const HelpTextTooltip = ({
  helpText,
  labelContainerRef,
}: HelpTextTooltipProps): JSX.Element | null => {
  if (!helpText || isDocEmpty(helpText.data)) {
    return null;
  }

  return (
    <div className={cx("form-field-control__tooltip")}>
      <Tooltip
        itemClasses="form-field-control__tooltip-content"
        contentBackground={GrayColors["G-0"]}
        arrowColor={GrayColors["G-0"]}
        placements={["top", "bottom"]}
        reposition
        padding={2}
        maxWidth={400}
        target={<IconButton name="info-baloon" size="XS" ariaLabel="info-baloon" />}
        renderTooltipContent={<SmartDocRenderer editorData={helpText} />}
        triggerOpenElement={labelContainerRef as unknown as React.RefObject<HTMLButtonElement>}
      />
    </div>
  );
};
